<template>
  <div id="esqueci-screen" class="container-fluid">
    <b-modal ref="modalErro" title="Atenção">{{msgValida}}</b-modal>

    <LeftPanel />

    <div class="right-panel d-flex align-items-center justify-content-center">

      <div v-if="stepRecupera">
        <div v-if="redefinida">
          <b-alert show fade variant="success" class="text-center pb-2">Sua senha foi redefinida!</b-alert>
          <b-button variant="success" block @click="$router.push({ name: 'login' })">Acesse sua conta</b-button>
        </div>
        <div v-else>

          <!-- Tela redefina sua senha -->

          <b-card tag="article" class="card-redefina-senha shadow-sm p-2">
            <h4 class="card-title">Redefina sua senha</h4>
            <b-card-text>Digite e confirme sua nova senha</b-card-text>
            <i><b-card-text v-html="this.email"></b-card-text></i>
            <!--<b-card-text v-html="this.documento"></b-card-text>-->
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-input-group class="mb-3">
                <b-form-input type="password" v-model="senha" :state="senha_state" placeholder="Nova senha"
                  @blur.native="validaPass"></b-form-input>
              </b-input-group>
              <b-input-group class="mb-3">
                <b-form-input type="password" v-model="senha_confirma" :state="senha_confirma_state"
                  placeholder="Confirmar nova senha"></b-form-input>
              </b-input-group>
              <b-alert :show="senhas_nao_conferem" fade variant="warning" class="text-center mt-3">As senhas não
                conferem.</b-alert>
              <b-alert :show="alertPassBasic" fade variant="warning" class="text-center mt-3">A senha deve conter ao
                menos:<br />
                <ul>
                  <li>8 caracteres</li>
                  <li>uma maiúscula</li>
                  <li>uma minúscula</li>
                  <li>um caracter especial</li>
                  <li>um número</li>
                </ul>
              </b-alert>
              <b-alert :show="msg_servidor.length > 0" fade variant="danger" class="text-center mt-3"
                v-html="msg_servidor"></b-alert>

              <b-input-group class="mt-4 form-group justify-content-end">
                <b-button variant="primary" block class="btn-lg" @click="redefinir()" id="btn-continuar">
                  <b-spinner id="loading-enviar" small type="grow" v-if="loading"></b-spinner>
                  Redefinir
                </b-button>
              </b-input-group>
            </b-form-group>
          </b-card>
          <!-- fim tela redefina sua senha -->
        </div>

      </div>
      <div v-else>

        <b-alert :show="enviado" fade variant="success" class="text-center">
          <!-- <h4>Solicitação enviada</h4> -->
          <p class="mb-0">Um e-mail foi enviado para {{ email }} com as instruções para redefinir sua senha.</p>
        </b-alert>


        <b-card v-if="!enviado" tag="article" class="shadow-sm p-2">
          <template v-if="stepLogin == 1">
            <h4 class="card-title">Recupere sua senha</h4>
            <b-card-text>Informe seu e-mail cadastrado</b-card-text>
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-input-group class="mb-3">
                <!-- <b-input-group-prepend>
                        <span class="input-group-text"><font-awesome-icon icon="envelope" /></span>
                    </b-input-group-prepend> -->
                <b-form-input type="email" placeholder="seu@email.com" v-model="email"
                  :state="email_state" @blur.native="valid"></b-form-input>
              </b-input-group>
              <b-input-group class="mb-3">
                <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" :sitekey="sitekey">
                </vue-recaptcha>
              </b-input-group>
              <b-alert :show="email_invalido" fade variant="warning">O e-mail informado não é válido.</b-alert>
              <b-alert :show="nao_cadastrado" fade variant="warning">O e-mail informado não está cadastrado.</b-alert>
              <b-alert :show="falta_token_recaptcha" fade variant="danger">Erro ao validar recaptcha.</b-alert>
              <b-input-group class="mt-4 form-group justify-content-end">
                <b-button variant="primary" block class="btn-lg" @click="enviar()" :disabled="!(email_state && !botaoEnviar)">
                  <b-spinner id="loading-enviar" small type="grow" v-if="loading"></b-spinner>
                  Enviar
                </b-button>
                <template>
                  <div>
                    <b-modal v-model="modalExibido" :hide-footer="true" title="Recuperar senha" :no-close-on-esc="true"
                      :no-close-on-backdrop="true">
                      <template v-slot:modal-title>
                        <h3 style="color: #597EB5">Recuperar senha</h3>
                      </template>
                      <p class="text-center mb-5">Deseja concluir a ação de recuperar a senha?</p>
                      <template>
                        <b-button variant="danger" @click="fecharModal">Cancelar</b-button>
                        <b-button variant="primary" @click="continuarRec" style="float: right;">Continuar</b-button>
                      </template>
                    </b-modal>
                  </div>
                </template>

              </b-input-group>
              <b-link class="btn-voltar mt-4" href="/login">
                Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
              </b-link>
            </b-form-group>
          </template>

          <template v-if="stepLogin == 2">
            <h4 class="card-title">Verifique sua conta</h4>
            <p class="mb-3">Selecione a opção para receber o código de verificação de conta:</p>
            <div id="token-option-selection">
              <div v-for="optionToken in optionTokenList" class="card-token-option-selection"
                @click="tokenOptionSelect = optionToken.value">
                <div class="d-flex justify-content-center p-2"
                  style="width:fit-content;border-radius: 14px;background-color: #4780F130;">
                  <img :src="getSVGIcon(optionToken.icon)" :style="'width: 22px;height: 22px;' + optionToken.iconStyle" />
                </div>
                <div class="d-flex flex-column text-card">
                  <h3>{{ optionToken.title }}</h3>
                  <span>{{ optionToken.text }}
                    <br>
                    {{ optionTokenText(optionToken.value) }}
                  </span>
                </div>
                <input type="radio" v-model="tokenOptionSelect" :value="optionToken.value" class="option-token">
              </div>
            </div>
            <b-button ref="btnLogin" variant="primary" class="btn-lg mb-2 problema-token-btn" block
              @click="requesitarToken2fa()" :disabled="!tokenOptionSelect">
              <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>
              Enviar código
            </b-button>
            <div class="text-center mb-2 problema-token">
              <a class="link" @click="$router.push({ name: 'recuperar-senha' })">Problemas com o Endereço de
                E-mail?<br>Entre em Contato com o Suporte.</a>
            </div>
          </template>
          <template v-if="stepLogin == 3">
            <div class="voltar-step-login" @click="stepLogin--">
              <span>Voltar</span>
            </div>
            <h4 class="card-title">Verificação em 2 etapas</h4>

            <div :class="'token-login-container' + (falha_login ? ' login-danger' : '')">
              <p>Digite o código de 6 dígitos que enviamos para seu email <b>{{ email }}</b></p>
              <div>
                <p class="label-token">Insira o código</p>
              </div>
              <div v-for="(char, index) in token2fa" class="token-login-input-container" style="display: inline-block;">
                <input :key="index" v-model="token2fa[index]" @input="handleInput2fa(index, $event)"
                  @keydown="handleKeyDown2fa(index, $event)" @paste="handlePaste2fa($event)" class="token-login-input m-2"
                  maxlength="1" :ref="`input_2fa_${index}`" placeholder="_" />
              </div>

              <div class="mb-4">
                <p class="token-error-msg" v-if="falha_login" fade>{{ falha_login_msg }}</p>
                <p v-if="timer2fa.current > 0">Reenviar código em {{ formatTimer(timer2fa.current) }}</p>
                <p v-else>
                  <a class="link" @click="reenviarToken2fa()">Reenviar código <b-spinner id="loading-entrar" small
                      type="grow" v-if="loading"></b-spinner></a>
                </p>
                <p>Se você não recebeu o código em seu email cadastrado dentro de 2 minutos, por favor, atualize e
                  verifique suas informações de contato ou considere verificar sua pasta e spam.</p>
              </div>
              <b-button id="btnConfirmaToken2fa" ref="btnConfirmaToken2fa" class="btnCadastro" @click="confirmaToken2fa()"
                :disabled="!(token2faString.length == token2fa.length)">
                <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>
                Confirmar código
              </b-button>
            </div>
          </template>

        </b-card>

      </div>
    </div>
  </div>
</template>

<script>
import LeftPanel from '../views/Login/LeftPanel.vue'
import Serv from "../services"
import API from '../services/api'
import VueRecaptcha from "vue-recaptcha";

export default {
  props: ['tipo_login'],
  components: {
    LeftPanel,
    VueRecaptcha
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptchaEsqueci,
      botaoEnviar: true,
      tokenRecaptcha: '',
      falta_token_recaptcha: false,
      alertPassBasic: false,
      documento: '',
      loading: false,
      msgValida: '',
      email: '',
      email_state: null,
      email_invalido: false,
      nao_cadastrado: false,
      enviado: false,
      hash: '',
      msg_servidor: '',
      falha_login: false,
      falha_login_msg: '',
      senha: '',
      senha_state: '',
      senha_confirma: '',
      senha_confirma_state: '',
      senhas_nao_conferem: false,
      redefinida: false,
      hash_valido: true,
      stepLogin: 1,
      modalExibido: false,
      token2fa: Array(6).fill(""),
      timer2fa: { current: 0, value: 120 },
      optionTokenList: [
        { title: 'Valide por E-mail', icon: 'envelope_icon', iconStyle: '', text: 'Enviar código via e-mail para ', value: 'email' },
      ],
      tokenOptionSelect: false,
      stepRecupera: false
    }
  },
  methods: {
    onVerify: function (response) {
      this.tokenRecaptcha = response;
      this.botaoEnviar = false
      this.tok = response
    },
    getSVGIcon(icon) {
      var images = require.context('../assets/imgs/svg/', false, /\.svg$/)
      return images('./' + icon + ".svg")
    },
    showModalError(error){
        this.msgValida = error;
        this.$refs["modalErro"].show();
    },
    async redefinir() {
      this.loading = true
      if (this.redefinirValid()) {

        const { senha, cpf, email } = this.$data
        const dados = { senha, cpf, email }
        const res = await API.post(`/esqueci/recuperar-senha`, dados)

        if (res.status === 200) {
          this.redefinida = true
        } else {
          this.msg_servidor = res.data.msg;
        }
      } else {
        this.loading = false
      }
    },
    redefinirValid() {
      this.senha_state = this.senha ? null : false
      this.senha_confirma_state = this.senha_confirma ? null : false

      if (this.senha !== this.senha_confirma) {
        this.senhas_nao_conferem = true
      } else if (this.senha && this.senha_confirma) {
        this.senhas_nao_conferem = false
        return true
      }
    },
    async enviar() {
      console.log("enviando...")
      console.log(this.email_state)
      if(this.email_state){
        let dados = { email: this.email, tok: this.tokenRecaptcha }
        this.modalExibido = true
      }
    },
    async continuarRec() {
      const res = await this.emailExists(this.email);

      if(res.success){
        this.stepLogin = 2
        this.enviado = false
        this.modalExibido = false
      }
      else{
        this.modalExibido = false
        this.email_state = false;
        this.nao_cadastrado = true;
        this.showModalError("Email informado não cadastrado!");
        return 0;
      }
      
    },
    emailExists(email){
      return new Promise((resolve, reject) => {
        const dados = { email: email };
        if (email){       
            API.post(`usuario/email`,dados).then((res) => {
                resolve(res.data);
            });
        }
        else throw new Error(false);
      });
    },
    valid() {
      this.nao_cadastrado = null;
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      let valid = emailRegex.test(this.email);
      if(valid && Serv.validarEmail(this.email)){
        this.email_state = true;
        this.email_invalido = null;
      }      
      else{
        this.email_state = false;
        this.email_invalido = false;
      }
    },
    fecharModal() {
      this.modalExibido = false
      window.location.href = '/login'
    },

    optionTokenText(option) {
      let text = '';
      switch (option) {
        case 'email': text = this.email; break;
        case 'sms': text = this.telefone; break;
        case 'wpp': text = this.wpp; break;
      }
      return text;
    },

    requesitarToken2fa() {
      this.stepLogin++
    },
    validaPass() {
      this.msg_servidor = '';

      let self = this
      let bt = document.getElementById('btn-continuar')
      // eslint-disable-next-line
      const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@()$%^&*=_{}[\]:;\"'|\\<>,.\/~`±§+-]).{8,30}$/;
      const str = this.senha;
      // eslint-disable-next-line
      let m;

      if ((m = regex.exec(str)) !== null) {
        self.alertPassBasic = false
        bt.disabled = false

      } else {
        self.alertPassBasic = true
        bt.disabled = true
      }
    },
    handleInput2fa(index, event) {
      if (event.target.value.match(/[0-9a-zA-Z]/)) {
        this.falha_login = false
        this.$set(this.token2fa, index, event.target.value);
        if (index < this.token2fa.length - 1) {
          this.$refs[`input_2fa_${index + 1}`][0].focus();
        }
      } else {
        this.$set(this.token2fa, index, "");
      }
    },
    handleKeyDown2fa(index, event) {
      if (event.key === "ArrowRight" && index < this.token2fa.length - 1) {
        this.$refs[`input_2fa_${index + 1}`][0].focus();
      } else if (event.key === "ArrowLeft" && index > 0) {
        this.$refs[`input_2fa_${index - 1}`][0].focus();
      } else if (event.key === "Tab") {
        event.preventDefault();
        if (event.shiftKey) {
          if (index > 0) {
            this.$refs[`input_2fa_${index - 1}`][0].focus();
          }
        } else {
          if (index < 7) {
            this.$refs[`input_2fa_${index + 1}`][0].focus();
          }
        }
      } else if (event.key === "Backspace" || event.key === "Delete") {
        event.preventDefault();
        this.falha_login = false
        this.$set(this.token2fa, index, "");
        if (index > 0) {
          this.$refs[`input_2fa_${index - 1}`][0].focus();
        }
      } else if (event.key.match(/[0-9a-zA-Z]/) && event.key.length === 1 && !event.ctrlKey) {
        if (this.token2fa[index] !== '') {
          this.falha_login = false
          this.$set(this.token2fa, index, event.key);
          event.preventDefault();
          this.$refs[`input_2fa_${index + 1}`][0].focus();
        }
      }
    },
    handlePaste2fa(event) {
      event.preventDefault();
      this.falha_login = false
      let pastedData = event.clipboardData.getData("text/plain");
      let pastedCharacters = pastedData.split("");
      let inputIndex = 0;
      pastedCharacters.forEach((char, index) => {
        if (char.match(/[0-9a-zA-Z]/) && inputIndex < this.token2fa.length) {
          this.$set(this.token2fa, inputIndex, char);
          inputIndex++;
        }
      });
      if (inputIndex < this.token2fa.length) {
        this.$refs[`input_2fa_${inputIndex}`][0].focus();
      }
      else {
        this.$nextTick(() => {
          this.$refs.btnConfirmaToken2fa.focus();
        });
      }

    },
    requesitarToken2fa() {
      this.reenviarToken2fa();
      this.stepLogin++;
    },
    confirmaToken2fa() {
      this.loading = true;
      API.post("/recupera-senha/validateToken2fa", { email: this.email, token2fa: this.token2faString }).then((res) => {
        let response = res.data

        localStorage.setItem("jwtToken", response.token)
        localStorage.setItem("tokenTermo", response.tokenTermo)
        sessionStorage.setItem("jwtToken", response.token)
        localStorage.setItem("usrName", response.name)
        localStorage.setItem("usrEmail", response.email)
        this.loading = false
        this.stepRecupera = true

      }).catch((error) => {
        let res = error.response.data
        if (res.error === 1)
          this.falha_login_msg = 'email não encontrado.'
        else if (res.error === 3)
          this.falha_login_msg = 'Token inválido.';
        else
          this.falha_login_msg = 'token inválido.'
        this.falha_login = true
        this.loading = false
        // this.resetRecaptcha()
      });
    },
    reenviarToken2fa() {
      this.loading = true;
      this.falha_login = false

      API.post("/recupera-senha/gerarToken2faRecupera", { email: this.email, token2faOpcao: this.tokenOptionSelect }).then((res) => {
        this.timer2fa.current = this.timer2fa.value;
        this.token2fa = Array(6).fill("");

        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      });
    },
    formatTimer(time) {
      return new Date(time * 1000).toISOString().substring(14, 19)
    },
  },
  mounted() {
    if (this.stepRecupera) {
      this.recupera = this.stepRecupera
    }
    // this.redefinida = true;
  },
  computed: {
    token2faString: function () {
      return this.token2fa.join('').toUpperCase();
    },
  },
  watch: {
    'timer2fa.current': {
      handler(value) {
        if (value > 0) setTimeout(() => { this.timer2fa.current--; }, 1000);
      },
      immediate: true,
    }
  },
}
</script>

<style>
::placeholder {
  color: #BBB;
}

.card-title.blueE {
  font: normal normal bold 25px/32px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  text-align: center;
}

.blueE {
  color: #004E86;
  font-size: 30px;
}

.logo {
  cursor: pointer;
  margin-bottom: 30px;
  height: 70px;
}

#esqueci-screen {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background-color: var(--main-bg-cinza); */
}

#esqueci-screen .right-panel {
  position: absolute;
  right: 0%;
  width: 50%;
  height: 100%;
}

#loading-enviar {
  vertical-align: 0;
  margin-left: -21px;
}

/* .card {
  border: 1px solid #597EB5;
  border-radius: 5px;
  padding: 38px 38px 38px 37px !important;
} */

.card-body h4 {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-align: center;
  margin-bottom: 32px;
}

.card-text {
  width: inherit;
  text-align: center;width: inherit;
  font-family: 'Kanit', sans-serif;
  font-size: 15px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-bottom: 10px;
  margin-left: 22px;
  margin-bottom: 10px;
}

.card-body input:active,
.card-body input:focus {
  background: #F1F1F1 0% 0% no-repeat padding-box;
}

.card-body input {
  border: 1px solid #FFFFFF;
  border-radius: 5px;
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  height: 35px;
  margin-bottom: 13px !important;
  background: #F1F1F1 0% 0% no-repeat padding-box;
}

.card-body button.btn-primary {
  color: #FFFFFF;
  padding: 9px 0;
  border-radius: 42px;
  height: 49px;
  background: var(--primary-color) 0% 0% no-repeat padding-box !important;
  border: none !important;
  text-align: center;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -1%;
}

.alert {
  max-height: 49px;
  padding: 15px 17px;
  border-radius: 5px;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  text-align: start !important;
}

.alert.alert-success {
  background: #CBF8D8 0% 0% no-repeat padding-box;
  color: #27703C;
}

.alert.alert-warning {
  background: #F8F5CB 0% 0% no-repeat padding-box;
  color: #706927;
}

.alert.alert-danger {
  background: #F8CBCB 0% 0% no-repeat padding-box;
  color: #702727;
}

.card-redefina-senha .alert {
  max-height: none;
  max-width: 303px;
}

.card-redefina-senha .alert ul {
  margin-bottom: 0;
}

.btn-success {
  background-color: #27703C;
  border-color: #27703C;
  font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
  letter-spacing: 0px;
}

@media (max-width: 780px) {
  #esqueci-screen .right-panel{
    position: absolute;
    right: 0%;
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 480px) {
  #esqueci-screen .right-panel {
    position: absolute;
    right: 0%;
    width: 100%;
    height: 100%;
  }
}

.btn-voltar {
  display: flex;
  align-items: center;
  margin-left: auto;
  text-decoration: none;
  justify-content: flex-end !important;
  margin-bottom: 20px;
  font-family: 'Kanit', sans-serif;
  font-size: 15px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
}

.btn-voltar img {
  width: 20px;
  height: 20px;
  margin-left: 6px;
}

.card-token-option-selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #597EB5;
  cursor: pointer;
  margin-bottom: 15px;
  border-radius: 8px;
  height: 120px;
  width: 304px;
  padding: 10px;
}

.card-body input {
  width: 303px;
  margin-bottom: 13px;
  border: 1px solid #FFFFFF;
  border-radius: 40px !important;
  text-align: left;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-transform: none;
  width: 303px;
  height: 44px;
  padding-left: 20px;
}

.card-token-option-selection:hover {
  box-shadow: 3px 3px 10px #00000052;
}

.card-token-option-selection input {
  width: 25px;
  height: 25px;
  margin: 0px !important;
}

.card-token-option-selection .text-card {
  width: 220px;
  text-align: center;
  margin: 0px 8px;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
}

.problema-token {
  width: 304px;
}
.btnCadastro{
  width: 304px;
}
button.problema-token-btn {
  width: 304px !important;
}
.card {
  max-width: 362px;
  box-shadow: 4px 4px 50px 0 #D1DBE2 !important;
  border-radius: 42px;
  border:none;
}
.card-token-option-selection h3 {
  font-family: 'Kanit', sans-serif;
  font-size: 15px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color) !important;
}
.card-body > p {
  max-width: 380px;
  text-align: left;
}
.voltar-step-login {
  display: flex;
  align-items: center;
  font-family: 'Kanit', sans-serif;
  font-size: 15px;
  font-weight: 200;
  letter-spacing: -1%;
  margin-bottom: 10px;
  cursor: pointer;
  width: fit-content;
  position: relative;
  margin-right: auto;
}

.voltar-step-login::before {
  content: '';
  display: flex;
  width: 10px;
  height: 10px;
  border-left: 2px solid var(--secondary-color);
  border-top: 2px solid var(--secondary-color);
  transform: rotate(-45deg);
  margin-right: 15px;
  transition: all 0.15s ease-in;
}

.voltar-step-login::after {
  content: '';
  display: flex;
  width: 15px;
  height: 2px;
  background-color: var(--secondary-color);
  position: absolute;
  top: 10px;
  left: 1px;
  transition: all 0.15s ease-in;
}

.voltar-step-login:hover::after {
  transform: translateX(-8px);
}

.voltar-step-login:hover::before {
  transform: rotate(-45deg) translateY(-6px) translateX(-6px);
}

@media (max-width: 540px) {

  .problema-token,
  button.problema-token-btn,
  .card-token-option-selection {
    max-width: calc(100vw - 34px - 20px);
  }

  .card-token-option-selection .text-card {
    margin: 0 5px;
    font-size: 13px;
    width: 190px;
  }

  .card-token-option-selection img {
    width: 20px !important;
    height: 20px !important;
  }

  .card-token-option-selection h3 {
    font-size: 15px;
  }

  .card-body .token-login-container .token-login-input-container input.token-login-input {
    width: 34px;
    height: 54.4px;
    font-size: 15px;
  }

  .card-body p {
    width: 100%;
  }
}

.card-body .token-login-container .token-login-input-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-body .token-login-container .token-login-input-container input.token-login-input {
  background: transparent;
  border: 1px solid #c3c3c3;
  width: 30px;
  height: 48px;
  text-transform: uppercase;
  text-align: center;
  vertical-align: middle;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  color: var(--secondary-color);
  margin-bottom: 0px;
  padding-left: 3px;
}

.card-body .token-login-container .token-login-input-container input.token-login-input:focus,
.card-body .token-login-container .token-login-input-container input.token-login-input:focus-visible {
  border-color: #4780F1 !important;
  border-width: 2px !important;
  outline: none !important;
}

.card-body .token-login-container .token-login-input-container input.token-login-input:focus::placeholder,
.card-body .token-login-container .token-login-input-container input.token-login-input:focus-visible::placeholder {
  color: transparent;
}

.card-body .token-login-container .token-login-input-container:nth-child(4)::after {
  content: '';
  width: 9px;
  height: 2px;
  background: #c3c3c3;
  /* margin: 0px 5px 0px 10px; */
}

.card-body .token-login-container.login-danger .token-login-input-container:nth-child(4)::after {
  background-color: #1ACEB5;
}

.token-login-container.login-danger .token-login-input-container input.token-login-input {
  border: 1px solid #1ACEB5;
  color: #1ACEB5;
  animation: tremble 5s ease-in-out 3;
}

p.token-error-msg {
  color: #1ACEB5;
  font-weight: bold;
  margin: 0px;
  text-align: center;
  width: 100%;
}

@media (max-width: 780px) {
  .input-group{
    max-width: 304px;
    width: calc(100vw - 78px);
  }
}

</style>

